module.exports = __webpack_public_path__ + "static/media/andreea_ciocilteu.d21984d6.jpg";